import { LinkSourceTypeEnum } from '../enums/link-source-type-enum'
import { LinkType } from '../type/link-type'

export const detectLinkSource = (link: LinkType) => {
  if (link.popupid) {
    return LinkSourceTypeEnum.Popup
  }

  if (link.href && link.href.startsWith('%BLOG')) {
    return LinkSourceTypeEnum.Blog
  }

  return LinkSourceTypeEnum.Input
}
